import axios from 'axios';
import React from 'react';
import ReactNotification from 'react-notifications-component';
import humanize from 'underscore.string/humanize';

import { addValidationPassedNotification, addValidationFailedNotification } from '../../../__util__/notifications';
import ascendingIdSort from '../../../__util__/sort';
import DropdownOptionsInput from './DropdownOptionsInput/DropdownOptionsInput';
import FieldTypeInput from './FieldTypeInput/FieldTypeInput';
import InstructionsInput from './InstructionsInput/InstructionsInput';
import PlaceholderInput from './PlaceholderInput/PlaceholderInput';

class InfoFieldForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      fieldType: 'string',
      placeholder: '',
      instructions: '',
      checked: false,
      dropdownOptions: [],
    };

    this.handleNameInput = this.handleNameInput.bind(this);
    this.handleFieldTypeInput = this.handleFieldTypeInput.bind(this);
    this.handlePlaceholderInput = this.handlePlaceholderInput.bind(this);
    this.handleInstructionsInput = this.handleInstructionsInput.bind(this);
    this.handleRequiredInput = this.handleRequiredInput.bind(this);
    this.handleAddDropdownOption = this.handleAddDropdownOption.bind(this);
    this.handleRemoveDropdownOption = this.handleRemoveDropdownOption.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.notificationDOMRef = React.createRef();
    // These methods have to be bound to class so jest tests can spy on them
    this.addValidationPassedNotification = addValidationPassedNotification.bind(this);
    this.addValidationFailedNotification = addValidationFailedNotification.bind(this);
  }

  // TODO: These handleInput methods can be condensed into one
  // Suggestions helpfully provided by Facebook
  // https://reactjs.org/docs/forms.html#handling-multiple-inputs
  handleNameInput(event) {
    this.setState({ name: event.target.value });
  }

  handleFieldTypeInput(event) {
    this.setState({ fieldType: event.target.value });
  }

  handlePlaceholderInput(event) {
    this.setState({ placeholder: event.target.value });
  }

  handleInstructionsInput(event) {
    this.setState({ instructions: event.target.value });
  }

  handleRequiredInput(event) {
    this.setState({ checked: !this.state.checked });
  }

  handleAddDropdownOption(text) {
    if (text === '') {
      return;
    }
    const { dropdownOptions } = this.state;
    const sortedArray = [...dropdownOptions].sort(ascendingIdSort);
    const nextId = sortedArray[sortedArray.length - 1] ? sortedArray[sortedArray.length - 1].id + 1 : 1;
    const newOption = { id: nextId, text: text };
    this.setState({ dropdownOptions: [...dropdownOptions, newOption] });
  }

  handleRemoveDropdownOption(id) {
    this.setState({ dropdownOptions: this.state.dropdownOptions.filter((t) => t.id !== id) });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { authenticityToken } = this.props;
    const { name, fieldType, placeholder, instructions, checked, dropdownOptions } = this.state;
    const required = checked ? 1 : 0; // convert boolean to backend expected string representation
    const formattedOptions = dropdownOptions.map((opt) => opt.text); // Rails backend expects array of string names only

    axios
      .post('/administration/info_fields.json', {
        authenticity_token: authenticityToken,
        info_field: {
          name: name,
          field_type: fieldType,
          placeholder: placeholder,
          instructions: instructions,
          dropdown_options: formattedOptions,
          required: required,
        },
      })
      .then((res) => {
        const ref = this.notificationDOMRef.current;
        if (res.data && res.data.data === 'success') {
          this.setState({
            name: '',
            fieldType: 'string',
            placeholder: '',
            instructions: '',
            checked: false,
            dropdownOptions: [],
          });

          // redirect as the Rails action does
          // Account::Administration::InfoFieldsController#create
          window.location.assign(`/administration/info_fields/${res.data.id}`);
          // this.addValidationPassedNotification(ref, 'Form successfully submitted!')
        } else if (res.data && res.data.data) {
          Object.keys(res.data.data).forEach((key) => {
            // Display Rails returned validation messages
            const message = `${humanize(key)} ${res.data.data[key]}`;
            this.addValidationFailedNotification(ref, message);
          });
        }
      });
  }

  placeholderInput = () => {
    if (this.state.fieldType == 'string' || this.state.fieldType == 'text') {
      return <PlaceholderInput handlePlaceholderInput={this.handlePlaceholderInput} />;
    }
  };

  instructionsInput = () => {
    if (this.state.fieldType != 'reviewed') {
      return <InstructionsInput handleInstructionsInput={this.handleInstructionsInput} />;
    }
  };

  dropdownOptionsInput = () => {
    if (this.state.fieldType == 'dropdown') {
      return (
        <DropdownOptionsInput
          dropdownOptions={this.state.dropdownOptions}
          handleAddDropdownOption={this.handleAddDropdownOption}
          handleRemoveDropdownOption={this.handleRemoveDropdownOption}
        />
      );
    }
  };

  render() {
    return (
      <div className="well clearfix">
        <ReactNotification ref={this.notificationDOMRef} />
        <h3>New Info Field</h3>

        <form onSubmit={this.handleSubmit}>
          <label>Name</label>
          <input id="#name" className="form-control" onChange={this.handleNameInput} />
          <hr />

          <FieldTypeInput handleFieldTypeInput={this.handleFieldTypeInput} />
          {this.placeholderInput()}
          {this.instructionsInput()}
          {this.dropdownOptionsInput()}

          <label>Required</label>
          <input
            id="#required"
            className="form-control"
            type="checkbox"
            checked={this.state.checked}
            onChange={this.handleRequiredInput}
          />
          <input id="#submit" type="submit" value="Create Info field" className="button" />
        </form>
      </div>
    );
  }
}

export default InfoFieldForm;
